import { Component, DestroyRef, inject, Input } from "@angular/core"
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser"
import { LanguageStateService } from "../../../common/services/language-state.service"
import { ConfirmDialogResult } from "../../../common/modules/Common-Components/confirm-popup/confirm-popup.component"

@Component({
    selector: 'app-provider-payment-iframe',
    templateUrl: './provider-payment-iframe.component.html',
    styleUrl: './provider-payment-iframe.component.scss',
    standalone: false
})
export class ProviderPaymentIframeComponent {

  @Input() paymentIFrameUrl = ''

  languageService: LanguageStateService = inject(LanguageStateService)
  sanitizer = inject(DomSanitizer)
  private destroyRef = inject(DestroyRef)

  iframeStarted = false
  iframeLoading = false
  iframeHeight = 620
  iframeSafeUrl: SafeResourceUrl = null
  showExternalPaymentDialog = false

  onBeginPaymentClicked() {
    this.iframeSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.paymentIFrameUrl);
    this.iframeStarted = true;
    this.iframeLoading = true;
    window.addEventListener('message', this.iframeMessageHandler);
    this.destroyRef.onDestroy(() => window.removeEventListener('message', this.iframeMessageHandler));
    // Safety net in case the iframe load event never fires
    setTimeout(() => this.onIframeLoaded(), 20000);
  }

  // Provider page posts {finalHeight} once rendered; resize the iframe to fit
  private iframeMessageHandler = (event: MessageEvent) => {
    if (!this.paymentIFrameUrl.startsWith(event.origin)) {
      return;
    }
    this.onIframeLoaded();
    try {
      const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      if (data?.finalHeight > 0) {
        this.iframeHeight = data.finalHeight;
      }
    } catch {
      // Ignore non-JSON messages from the provider page
    }
  }

  onIframeLoaded() {
    this.iframeLoading = false;
  }

  onOpenExternalPaymentDialog() {
    this.showExternalPaymentDialog = true;
  }

  onExternalPaymentModalResult(result: ConfirmDialogResult) {
    this.showExternalPaymentDialog = false;
    if ((result?.data as { success: boolean })?.success && this.paymentIFrameUrl) {
      window.open(this.paymentIFrameUrl, '_blank');
    }
  }
}
